/**
 * 12-color palette for cluster visualization.
 * Colors chosen for good contrast across light/dark modes.
 */
const CLUSTER_PALETTE = [
  "#3b82f6", // blue
  "#ef4444", // red
  "#22c55e", // green
  "#f59e0b", // amber
  "#8b5cf6", // violet
  "#ec4899", // pink
  "#14b8a6", // teal
  "#f97316", // orange
  "#6366f1", // indigo
  "#06b6d4", // cyan
  "#84cc16", // lime
  "#a855f7", // purple
];

/**
 * Get a color for a cluster ID. Cycles through the palette.
 */
export function clusterColor(clusterId: number): string {
  if (clusterId < 0) return "#94a3b8"; // slate for unclustered
  return CLUSTER_PALETTE[clusterId % CLUSTER_PALETTE.length];
}
